import { atom } from 'jotai';

export type Locale = 'fr' | 'en';

function getInitialLocale(): Locale {
  if (typeof navigator === 'undefined') return 'en';
  const lang = navigator.language?.toLowerCase() ?? '';
  return lang.startsWith('fr') ? 'fr' : 'en';
}

export const localeAtom = atom<Locale>(getInitialLocale());
